var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.name,{tag:"component",staticClass:"ui-icon",class:_vm.rootClasses})
}
var staticRenderFns = []

export { render, staticRenderFns }